// extracted by mini-css-extract-plugin
export var container = "_o3-0";
export var dotAnimation = "_o3-2";
export var dotsLoading = "_o3-1";